import createCache from "@emotion/cache";

const emotionInsertionPoint =
  (typeof document !== "undefined" &&
    (document.querySelector(
      "meta[name=emotion-insertion-point]",
    ) as HTMLMetaElement | null)) ||
  null;

export const createEmotionCache = () =>
  createCache({
    key: "css",
    // speedy: false,
    insertionPoint: emotionInsertionPoint || undefined,
  });
